import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Typography,
  Box,
  Fab,
  AppBar,
  Toolbar,
  IconButton,
  TextField,
  InputAdornment,
  Stack,
  Badge,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SendIcon from '@mui/icons-material/Send';
import ForumIcon from '@mui/icons-material/Forum';
import useAPI from '../../../api';
import MessageBox from './MessageBox';

const Message = function Message(
  m,
  previousItem,
  handleReadMessage,
  campaignId
) {
  if (!m) return null;
  const {
    id,
    sender,
    content,
    outbound,
    readByFullName,
    readOn,
    performedOn,
    createdOn,
    status,
    outcome,
    campaignAdvancement,
  } = m || {};

  return (
    <MessageBox
      previousItem={previousItem}
      msgId={id}
      status={status}
      sender={sender}
      value={content}
      outbound={outbound}
      outcome={outcome}
      campaignAdvancement={campaignAdvancement}
      readBy={readByFullName}
      readOn={readOn}
      performedOn={performedOn || createdOn}
      handleReadMessage={handleReadMessage}
      campaignId={campaignId}
    />
  );
};

const ChatBox = function ChatBox({
  close,
  handleSendMessage,
  subtractSmsNumber,
  ObserverWrapper = null,
  messages = [],
  campaignId,
  updateItem,
}) {
  const API = useAPI();
  const intl = useIntl();

  const [textValue, setTextValue] = useState('');

  const handleReadMessage = (mId) => {
    API.setMessageRead(
      mId,
      (result) => {
        updateItem(result);
        subtractSmsNumber();
      },
      (err) => {
        console.log(err);
      }
    );
  };

  return (
    <div
      style={{
        overflow: 'hidden',
        width: '500px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AppBar
        sx={{
          position: 'relative',
          borderRadius: 'unset',
          color: 'white.main',
        }}
      >
        <Toolbar>
          <ForumIcon />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {intl.messages.CHAT}
          </Typography>
          <IconButton color="inherit" onClick={close}>
            <KeyboardArrowDownIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          flexGrow: 1,
        }}
      >
        <Stack
          spacing={2}
          direction="column-reverse"
          sx={{
            overflow: 'auto',
            pl: '24px',
            pr: '24px',
            flexGrow: 1,
          }}
        >
          <ObserverWrapper
            Component={(m, index) =>
              Message(
                m,
                messages.length > 0 ? messages[index + 1] : {}, //next item
                handleReadMessage,
                campaignId
              )
            }
          />
        </Stack>
        <Box
          sx={{
            display: 'flex',
            gap: '8px',
            p: '16px',
            alignItems: 'center',
          }}
        >
          <TextField
            multiline
            sx={{
              flexGrow: 1,
              borderRadius: '10px',
              [`& fieldset`]: {
                borderRadius: '10px',
              },
            }}
            size="small"
            placeholder={intl.messages.WRITE_MESSAGE}
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    {textValue.length}
                  </InputAdornment>
                ),
              },
            }}
          />

          <Fab
            color="primary"
            size="small"
            disabled={!textValue || textValue === ''}
            onClick={() => {
              handleSendMessage(textValue);
              setTextValue('');
            }}
          >
            <Badge
              badgeContent={
                (textValue && Math.ceil(textValue.length / 160)) || 0
              }
              color="warning"
            >
              <SendIcon />
            </Badge>
          </Fab>
        </Box>
      </div>
    </div>
  );
};

export default ChatBox;
